(function () {
  const key = 'marcapp_campaign_v1';
  const fields = { gclid: 'gclid', fbclid: 'fbclid', utm_source: 'utmSource', utm_medium: 'utmMedium', utm_campaign: 'utmCampaign', utm_content: 'utmContent', utm_term: 'utmTerm' };
  function permission() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return { analyticsAllowed: Boolean(privacy && privacy.analyticsProcessingAllowed()), marketingAllowed: Boolean(privacy && privacy.marketingAllowed()) };
    } catch { return { analyticsAllowed: false, marketingAllowed: false }; }
  }
  function capture() {
    const allowed = permission();
    try {
      if (!allowed.analyticsAllowed || !allowed.marketingAllowed) { sessionStorage.removeItem(key); return; }
      const params = new URLSearchParams(window.location.search);
      const values = {};
      Object.keys(fields).forEach(name => {
        const value = params.get(name);
        const max = name === 'gclid' || name === 'fbclid' ? 1024 : name === 'utm_source' || name === 'utm_medium' ? 120 : 240;
        if (value && value.length <= max && !/[\u0000-\u001f]/.test(value)) values[fields[name]] = value;
      });
      if (Object.keys(values).length) sessionStorage.setItem(key, JSON.stringify({ version: 1, savedAt: Date.now(), values: values }));
    } catch {}
  }
  function attribution() {
    capture();
    const allowed = permission();
    if (!allowed.analyticsAllowed || !allowed.marketingAllowed) return allowed;
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved && saved.version === 1 && Date.now() - saved.savedAt < 86400000) return Object.assign({}, saved.values, allowed);
      sessionStorage.removeItem(key);
    } catch {}
    return allowed;
  }
  window.MarcappQuoteRequest = function (cart, form) {
    const value = id => (form.querySelector('#' + id) || {}).value || '';
    const data = {
      schemaVersion: 1, shop: 'marcable.cl', requestId: crypto.randomUUID(), submittedAt: new Date().toISOString(),
      contact: { name: value('Cot-nombre'), email: value('Cot-email'), company: value('Cot-empresa'), phone: value('Cot-fono') },
      items: cart.items.map(item => ({ productId: String(item.product_id), variantId: String(item.variant_id), sku: item.sku || '', name: item.product_title, variant: item.variant_title || '', quantity: item.quantity })),
      companyTaxId: value('Cot-rut'), personalization: value('Cot-impresion'), requestedDate: value('Cot-fecha'), deliveryLocation: value('Cot-comuna'), comments: value('Cot-comentarios'), logoUrl: value('Cot-logo-url'), attribution: attribution()
    };
    const bytes = new TextEncoder().encode(JSON.stringify(data));
    if (bytes.length > 65000 || !data.items.length || data.items.length > 100) throw new Error('request-size');
    let binary = '';
    bytes.forEach(byte => { binary += String.fromCharCode(byte); });
    return 'MARCAPP_REQUEST_V1:' + btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '') + ':END_MARCAPP_REQUEST';
  };
  document.addEventListener('visitorConsentCollected', capture);
  capture();
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => { if (!error) capture(); });
  }
})();
